import React, {useState} from 'react';

import {hooks} from '../../hooks';
import {Routes} from '../../routes';
import {MenuType, MenuCatType} from '../../types';
import {components} from '../../components';

export const Menu: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const navigate = hooks.useNavigate();

  const {menuLoading, menu} = hooks.useGetMenu();
  const {menuCatLoading, menuCat} = hooks.useGetMenuCat();

  const [opacity, setOpacity] = useState<number>(0);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderMenuCat = (): JSX.Element => {
    return (
      <section style={{paddingTop: 10}}>
        <ul
          style={{
            display: 'grid',
            gap: 15,
          }}
        >
          {menuCat.map((menuCat: MenuCatType, index: number, array: MenuCatType[]) => {
            return (
              <li
                key={menuCat.id}
                className='clickable'
                style={{
                  position: 'relative',
                  width: '100%',
                  height: 150,
                  borderRadius: 10,
                  overflow: 'hidden',
                  backgroundColor: 'var(--main-turquoise)',
                }}
                onClick={() =>
                  navigate(menuCat.path, {state: {menuName: menuCat.title}})
                }
              >
                {/* <img
                  src={menuCat.image}
                  alt={menuCat.title}
                  style={{borderRadius: 10, width: '100%', height: 'auto'}}
                /> */}
                <div style={{position: 'absolute', left: 15, bottom: 10}}>
                  <span
                    className='t16 number-of-lines-1'
                    style={{color: 'var(--white-color)'}}
                  >
                    {menuCat.title}
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      </section>
    );
  };

  const renderContent = (): JSX.Element | null => {
    if (menuLoading && !menu.length) return null;
    return <main className='scrollable container'>{renderMenuCat()}</main>;
  };

  const renderLoader = (): JSX.Element | null => {
    if (menuLoading) return <components.Loader />;
    return null;
  };

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderLoader()}
      {renderContent()}
    </div>
  );
};
